import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "../Pages/Home";
import About from "../Pages/About";
import WhyDonate from "../Pages/WhyDonate";
import Ways2give from "../Pages/Ways2give";
import Givingopportunity from "../Pages/Givingopportunity";
import Resources from "../Pages/Resources";
import Gallery from "../Pages/Gallery";
import Calendar from "../Pages/Calendar";
import Blog from "../Pages/Blog";
import Team from "../Pages/Team";
import Newsletter from "../Pages/Newsletter";
import Contact from "../Pages/Contact";
import Events from "../Pages/Events";


function App() {
  return (
    <div>      
        <Routes>
          <Route exact path='/' element={<Home />}></Route>          
          <Route exact path='/about' element={<About />}></Route>
          <Route exact path='/donate' element={<WhyDonate />}></Route>
          <Route exact path='/ways2give' element={<Ways2give />}></Route>
          <Route exact path='/givingopportunity' element={<Givingopportunity />}></Route>
          <Route exact path="/resources" element={<Resources />}></Route>
          <Route exact path="/gallery" element={<Gallery />}></Route>
          <Route exact path="/calendar" element={<Calendar />}></Route>
          <Route exact path="/blog" element={<Blog />}></Route>
          <Route exact path="/team" element={<Team/>}></Route>
          <Route exact path="/waystogivenew" element={<Ways2give/>}></Route> 
          <Route exact path="/newsletter" element={<Newsletter/>}></Route> 
          <Route exact path="/contact" element={<Contact/>}></Route> 
          <Route exact path="/events" element={<Events/>}></Route> 
          <Route exact path="*" element={<Navigate to="/" replace />}/>
        </Routes>
    </div>
  );
}

export default App;
